import React, { useEffect, useState, useCallback } from 'react';
import useApp from 'hooks/useApp'
import { Select, Logo, Layer } from 'components'
import styles from '../index.module.css'
import Lib from 'library';
import { financeLoanDetailState_1 } from './states'
import { useRecoilState } from 'recoil'

const FinanceLoanDetailLayer_1 = () => {

	const App = useApp()
	const [layerControl, setLayerControl] = useRecoilState(financeLoanDetailState_1)
	// const seq = layerControl.seq;
	// const dclsMonth = layerControl.dclsMonth;
	// const finCoNo = layerControl.finCoNo;
	// const finPrdtCd = layerControl.finPrdtCd;
	// const mortgage = layerControl.data;
	const fmiId = layerControl.fmiId; // 상세 id
	const lendRateMin = layerControl.lendRateMin; // 최저금리
	const [mortgage, setMortgage] = useState(null); // 상세 api 조회 데이터

	const [savingOpLst, setSavingOpLst] = useState(null);

	const [mrtg, setMrtg] = useState();
	const [rpay, setRpay] = useState("");
	const [lend, setLend] = useState("");

	const [saveMrtgLst, setSaveMrtgLst] = useState(null);
	const [saveRpayLst, setSaveRpayLst] = useState(null);
	const [saveLendLst, setSaveLendLst] = useState(null);

	const [resultLst, setResultLst] = useState(null);

	const [accordionOpen, setAccordionOpen] = useState(true)

	const openAccordion = () => {
		setAccordionOpen(!accordionOpen)
	}

	const savingRate = (data) => {
		// 담보유형
		const mrtgOptions = new Map(data.map(sav => [sav.mrtgTypeNm]));
		const _saveMrtg = [...mrtgOptions].map(([nm]) => ({ 'mrtg_type': nm, 'mrtg_type_nm': nm }));
		setSaveMrtgLst(_saveMrtg);

		// 대출상환유형
		const rpayOptions = new Map(data.map(sav => [sav.rpayTypeNm]));
		const _saveRpay = [...rpayOptions].map(([nm]) => ({ 'rpay_type': nm, 'rpay_type_nm': nm }));
		setSaveRpayLst(_saveRpay);

		// 대출금리유형
		const lendOptions = new Map(data.map(sav => [sav.lendRateTypeNm]));
		const _saveLend = [...lendOptions].map(([nm]) => ({ 'lend_rate_type': nm, 'lend_rate_type_nm': nm }));
		setSaveLendLst(_saveLend);

		// 선택, 조회 초기값 적용
		setMrtg(_saveMrtg[0].mrtg_type);
		setRpay(_saveRpay[0].rpay_type);
		setLend(_saveLend[0].lend_rate_type);
	}

	// 주택 getMortgageDetailOption
	const getMortgageDetailOption = (fmiId) => {
		Lib.myGet(`/api/recomm/mortgage/v1/${fmiId}`, (data) => {
			console.log('주택 상세', data.data)
			setSavingOpLst(data.data.options);
			savingRate(data.data.options);
			setMortgage(data.data);
		});
		// Lib.post(`/api/finance/mortgageLoanOption?dclsMonth=${month}&finCoNo=${codeNo}&finPrdtCd=${prdtCode}`, (data) => {
		// 	setSavingOpLst(data);
		// 	savingRate(data);
		// });
	}

	useEffect(() => {
		layerControl.show && getMortgageDetailOption(fmiId);
		console.log('최저금리', lendRateMin)
	}, [fmiId, layerControl.show, lendRateMin])

	const onResultSeleted = useCallback((key, value, set) => {
		set(value);
	}, [mrtg, rpay, lend]);

	useEffect(() => {
		const _selectedData = savingOpLst && savingOpLst.find(v => v.mrtgTypeNm === mrtg && v.rpayTypeNm === rpay && v.lendRateTypeNm === lend);
		console.log(_selectedData);
		setResultLst(_selectedData);
	}, [mrtg, rpay, lend]);

	if (!mortgage) return null;

	return (
		<Layer show={layerControl.show} closeLayer={() => setLayerControl(prev => ({ ...prev, show: false }))}>
			<div className="page">
				<div className="shadow">
					<div className="padding">
						<div className="flex-justify_between align_center mt_10">
							<div className={styles["detail-title"]}>
								<span>{mortgage.korCoNm}</span>
								<p className="mt_5">{mortgage.finPrdtNm}</p>
								<i className="tag tag-box tag-red mt_10">주택담보대출</i>
							</div>
							{/* <div className="img-box img-symbol img-symbol-lg ml_10">
								<Logo code={mortgage.fin_co_no} style={{ 'width': '6rem', 'height': '6rem' }} />
							</div> */}
						</div>
						<ul className={`${styles["count-list"]} mt_20`}>
							<li style={mortgage.loanLmt.split('\n').length > 10 ? { 'width': '16rem' } : {}}>
								<p>최저금리</p>
								<strong>{!lendRateMin ? "-" : `${Number(lendRateMin).toFixed(2)}%`}</strong>
							</li>
							{/* <li style={mortgage.loanLmt.split('\n').length > 10 ? { 'width': '16rem' } : {}}>
								{!mortgage.minRate ? (
									<>
										<p>평균금리</p>
										<strong>{!mortgage.lend_rate_avg ? "-" : `${mortgage.lend_rate_avg.toFixed(2)}%`}</strong>
									</>
								) : (
									<>
										<p>최저금리</p>
										<strong>{!mortgage.minRate ? "-" : `${Number(mortgage.minRate).toFixed(2)}%`}</strong>
									</>
								)}
							</li> */}
							<li style={mortgage.loanLmt.split('\n').length > 10 ? { 'width': 'auto' } : {}}>
								<p>대출한도</p>
								{mortgage.loanLmt.split('\n')
									.map(item => (
									<strong key={item}>
										{item}
									</strong>
									))}
							</li>
						</ul>
					</div>
				</div>
				<div className="shadow">
					<div className="padding">
						<div className={`${accordionOpen ? "active" : ""} accordion-title flex-justify_between align_center`} onClick={openAccordion}>
							<h3>내가 이 대출을 받는다면?</h3>
							<i className="icon icon_accordion_arrow" />
						</div>
						<div className="accordion-content">
							<div className="flex-justify_center mt_40">
								<i className="icon icon_finance_loan" />
							</div>
							<div className={`${styles["question-area"]} mt_20`}>
								<div className={styles.sec}>{mortgage.finPrdtNm} 상품을</div>
								<div className={styles.sec}>
									<Select
										className="mr_10"
										title="담보유형"
										selected={mrtg}
										data={saveMrtgLst && saveMrtgLst.map((mrtg) => (
											{ key: `${mrtg.mrtg_type_nm}`, value: `${mrtg.mrtg_type}` }
										))}
										onSelect={(key, value) => onResultSeleted(key, value, setMrtg)}
									>
									</Select>
									담보로
									<Select
										className="mx_10"
										title="대출상환유형"
										selected={lend}
										data={saveLendLst && saveLendLst.map((lend) => (
											{ key: `${lend.lend_rate_type_nm}`, value: `${lend.lend_rate_type}` }
										))}
										onSelect={(key, value) => onResultSeleted(key, value, setLend)}
									>
									</Select>
									를
								</div>
								<div className={styles.sec}>
									<Select
										className="mx_10"
										title="대출금리유형"
										selected={rpay}
										data={saveRpayLst && saveRpayLst.map((rpay) => (
											{ key: `${rpay.rpay_type_nm}`, value: `${rpay.rpay_type}` }
										))}
										onSelect={(key, value) => onResultSeleted(key, value, setRpay)}
									>
									</Select>
									으로 상환할 경우
								</div>
							</div>
							{resultLst && resultLst.lendRateAvg &&
								<div className={`${styles["answer-box"]} mt_20`}>
									{(resultLst.lendRateMin && resultLst.lendRateMax) && (<><strong>{parseFloat(resultLst.lendRateMin).toFixed(2)}% ~ {parseFloat(resultLst.lendRateMax).toFixed(2)}%</strong> 금리를 받아요!<br /></>)}
									전월 취급 평균 금리는 <strong>{parseFloat(resultLst.lendRateAvg).toFixed(2)}%</strong>네요.
								</div>
							}
						</div>
					</div>
				</div>
				<div className="padding">
					<ul className="list-item list-item-left" style={{ fontSize: "1.2rem" }}>
					    {
                            ( mortgage.joinWay != null && mortgage.joinWay != "-" ) &&
                            <li>
                                <span>가입방법</span>
                                <span>{mortgage.joinWay}</span>
                            </li>
						}
						{
                            ( mortgage.loanInciExpn != null && mortgage.loanInciExpn != "-" ) &&
                            <li>
                                <span>대출 부대비용</span>
                                <span style={{ whiteSpace: "pre-wrap" }}>{mortgage.loanInciExpn}</span>
                            </li>
						}
						{
                            ( mortgage.erlyRpayFee != null && mortgage.erlyRpayFee != "-" ) &&
                            <li>
                                <span>중도상환<br />수수료</span>
                                <span style={{ whiteSpace: "pre-wrap" }}>{mortgage.erlyRpayFee}</span>
                            </li>
					    }
					    {
                            ( mortgage.dlyRate != null && mortgage.dlyRate != "-" ) &&
                            <li>
                                <span>연체 이자율</span>
                                <span>{mortgage.dlyRate}</span>
                            </li>
						}
						{
                            ( mortgage.dclsStrtDay != null || mortgage.dclsEndDay != null ) &&
                            <li>
                                <span>공시 기간</span>
                                <span>{`${mortgage.dclsStrtDay} ~ ${!mortgage.dclsEndDay ? "" : mortgage.dclsEndDay}`}</span>
                            </li>
						}
					</ul>
					<div className={`${styles["list-guide"]} mt_50`}>금융감독원의 금융상품 API를 통해 제공하는 정보입니다.</div>
				</div>
			</div>
		</Layer>
	)
}

export default FinanceLoanDetailLayer_1